import { render, staticRenderFns } from "./TaskDone.vue?vue&type=template&id=2899752e&scoped=true"
import script from "./TaskDone.vue?vue&type=script&lang=js"
export * from "./TaskDone.vue?vue&type=script&lang=js"
import style0 from "./TaskDone.vue?vue&type=style&index=0&id=2899752e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899752e",
  null
  
)

export default component.exports